export default {
    mounted(el, binding) {
        const operationKey = binding.value;
        if (!operationKey) return;

        const cost = window.GlobalConfigVariables?.[operationKey];
        if (!cost || cost <= 0) return;

        const badge = document.createElement('span');
        badge.className = 'ai-cost-badge inline-flex items-center ml-2 px-1.5 py-0.5 rounded-full text-xs font-medium bg-secondary-100 text-secondary-700';
        badge.textContent = `${cost} T.`;

        el.appendChild(badge);
    }
}
